module.exports = __webpack_public_path__ + "static/media/lawful_shrine.4494f90b.png";